import _cloneDeep from 'lodash/cloneDeep';

export default class RoleUsersController {
    /** @ngInject */
    constructor(EventEmitter, UsersApi) {
        this.eventEmitter = EventEmitter;
        this.UsersApi = UsersApi;
    }

    $onInit() {
        if (!Array.isArray(this.users)) {
            this.users = [];
        }

        this.searchText = '';
        this.pendingSearch = null;
        this.lastSearch = 0;
        this.defaulImageUrl = '/assets/images/avatar.png';
    }

    $onChanges(changes) {
        if (changes.users) {
            if (!changes.users.isFirstChange() && !Array.isArray(changes.users.currentValue)) {
                this.users = [];
            }

            this.searchText = '';
        }
    }

    selectedUserChange(user) {
        this.selectedUser = user;
    }

    searchUsers(criteria) {
        this.pendingSearch = this.UsersApi.search(criteria).then((response) => {
            let data = [];
            if (response && response.users && response.users.length) {
                data = response.users;
            }

            data = data.map((user) => {
                if (!('first_name' in user) || !('last_name' in user)) {
                    user.fullName = 'NoNaMe';
                } else {
                    user.fullName = `${user.first_name} ${user.last_name}`;
                }
                if (!user.image) {
                    user.image = this.defaulImageUrl;
                }

                return user;
            });

            data = data.filter((user) => {
                let result = true;
                const length = this.users.length;

                if (!length) return result;

                for (let i = 0; i < length; i++) {
                    if (this.users[i].id === user.id) {
                        result = false;
                        break;
                    }
                }

                return result;
            });

            return data;
        });

        return this.pendingSearch;
    }

    onAdd(user) {
        this.onAddUser(this.eventEmitter({
            user: _cloneDeep(user)
        }));

        this.searchText = '';
    }

    onRemove(user) {
        this.onRemoveUser(this.eventEmitter({
            user: _cloneDeep(user)
        }));
    }
}



// WEBPACK FOOTER //
// ./app/components/users-and-access/roles/role-users/role-users.controller.js